$(window).on('load', function() {
	$(document).ready(function() {

		// Gibt Fred eine neue Klasse mit
		$.fn.onClassChange = function(cb) {
		  return $(this).each((_, el) => {
		    new MutationObserver(mutations => {
		      mutations.forEach(mutation => cb && cb(mutation.target, $(mutation.target).prop(mutation.attributeName)));
		    }).observe(el, {
		      attributes: true,
		      attributeFilter: ['class'] // only listen for class attribute  changes
		    });
		  });
		}
		
		$("div[class*='fon_bubble-visible']").addClass("fredTablet");
		$("div[class*='fon_bubble']").onClassChange(() => $("div[class*='fon_bubble-visible']").addClass("fredTablet"));
 
	});
});